/* eslint-disable no-redeclare */
/* eslint-disable import/no-anonymous-default-export */
/*
    Customer Dashboard Reducer
    
*/
import _ from "lodash";
import moment from "moment";
import {
  GET_CUSTOMERDASHBOARDDATA,
  GET_CUSTOMERDASHBOARDDATA_FAILURE,
  GET_CUSTOMERDASHBOARDDATA_SUCCESS,
  GET_CUSTOMER_LIST_FOR_DASHBOARD,
  GET_CUSTOMER_LIST_FOR_DASHBOARD_FAILURE,
  GET_CUSTOMER_LIST_FOR_DASHBOARD_SUCCESS,
  SELECT_DASHBOARD_CUSTOMER,
} from "../actions/types";
// initial state
const INIT_STATE = {
  dashboardData: [],
  filterDomains: [],
  filterModel: {
    type: "hour",
    text: "Last 12 hours",
    value: 12,
  },
  profilesStats: {
    new: 0,
    revisits: 0,
    updates: 0,
  },
  domainStats: [],
  browserStats: [],
  opPresent: false,
  mpPresent: false,
  reportType: null,
  filterDays: 0,
  loading: false,
  selectedCustomer: null,
  customers: [],
  noDataStatus: false,
  trendSeries: [],
  trendDays: [],
  chartData: {
    series: [],
    options: {
      chart: {
        height: 300,
        type: "bar",
        stacked: true,
        zoom: {
          enabled: false,
        },
        fontFamily: "Montserrat, Helvetica Neue, Arial, sans-serif",
      },
      dataLabels: {
        enabled: false,
      },

      title: {
        text: "Observed profile day wise event statistics",
        align: "center",
      },
      legend: {
        show: false,
        tooltipHoverFormatter: function (val, opts) {
          return (
            val +
            " - " +
            opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] +
            ""
          );
        },
      },
      markers: {
        size: 0,
        hover: {
          sizeOffset: 6,
        },
      },
      xaxis: {
        categories: [],
      },
      tooltip: {
        y: [
          {
            title: {
              formatter: function (val) {
                return val;
              },
            },
          },
          {
            title: {
              formatter: function (val) {
                return val;
              },
            },
          },
          {
            title: {
              formatter: function (val) {
                return val;
              },
            },
          },
        ],
      },
      colors: ["#FFA100", "#cc8100", "#919191"],
      grid: {
        borderColor: "#f1f1f1",
      },
    },
  },
  mpChartData: {
    series: [],
    options: {
      chart: {
        height: 300,
        type: "bar",
        stacked: true,
        zoom: {
          enabled: false,
        },
        fontFamily: "Montserrat, Helvetica Neue, Arial, sans-serif",
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        width: [2, 2, 2, 2],
        curve: "smooth",
      },
      title: {
        text: "Micro profile day wise event statistics",
        align: "center",
      },
      legend: {
        show: false,
        tooltipHoverFormatter: function (val, opts) {
          return (
            val +
            " - " +
            opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] +
            ""
          );
        },
      },
      markers: {
        size: 0,
        hover: {
          sizeOffset: 6,
        },
      },
      xaxis: {
        categories: [],
      },
      tooltip: {
        y: [
          {
            title: {
              formatter: function (val) {
                return val;
              },
            },
          },
          {
            title: {
              formatter: function (val) {
                return val;
              },
            },
          },
          {
            title: {
              formatter: function (val) {
                return val;
              },
            },
          },
          {
            title: {
              formatter: function (val) {
                return val;
              },
            },
          },
        ],
      },
      colors: ["#FFA100", "#cc8100", "#919191", "#4183c4"],
      grid: {
        borderColor: "#f1f1f1",
      },
    },
  },
  cmpChartData: {
    series: [],
    options: {
      chart: {
        height: 300,
        type: "bar",
        stacked: true,
        zoom: {
          enabled: false,
        },
        fontFamily: "Montserrat, Helvetica Neue, Arial, sans-serif",
      },
      plotOptions: {
        bar: {
          horizontal: false,
          borderRadius: 10,
        },
      },
      dataLabels: {
        enabled: false,
      },

      title: {
        text: "CMP day wise event statistics",
        align: "center",
      },
      legend: {
        show: false,
        tooltipHoverFormatter: function (val, opts) {
          return (
            val +
            " - " +
            opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] +
            ""
          );
        },
      },
      markers: {
        size: 0,
        hover: {
          sizeOffset: 6,
        },
      },
      xaxis: {
        categories: [],
      },
      tooltip: {
        y: [
          {
            title: {
              formatter: function (val) {
                return val;
              },
            },
          },
          {
            title: {
              formatter: function (val) {
                return val;
              },
            },
          },
          {
            title: {
              formatter: function (val) {
                return val;
              },
            },
          },
          {
            title: {
              formatter: function (val) {
                return val;
              },
            },
          },
          {
            title: {
              formatter: function (val) {
                return val;
              },
            },
          },
          {
            title: {
              formatter: function (val) {
                return val;
              },
            },
          },
          {
            title: {
              formatter: function (val) {
                return val;
              },
            },
          },
        ],
      },
      colors: [
        "#FFA100",
        "#cc8100",
        "#919191",
        "#ffb433",
        "#664000",
        "#747474",
        "#b2b2b2",
        "#494949",
        "#d3d3d3",
      ],

      grid: {
        borderColor: "#f1f1f1",
      },
    },
  },
  cmpStats: {
    loaded: 0,
    layer1Visible: 0,
    layer1OptinAll: 0,
    layer1OptoutAll: 0,
    layer2Visible: 0,
    layer2OptinAll: 0,
    layer2OptoutAll: 0,
    layer2Selected: 0,
    previousOptin: 0,
  },
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SELECT_DASHBOARD_CUSTOMER:
      return {
        ...state,
        selectedCustomer: action.payload,
        noDataStatus: false,
      };
    case GET_CUSTOMER_LIST_FOR_DASHBOARD:
      return { ...state };
    case GET_CUSTOMER_LIST_FOR_DASHBOARD_SUCCESS:
      return { ...state, customers: action.payload.data };
    case GET_CUSTOMER_LIST_FOR_DASHBOARD_FAILURE:
      return { ...state };
    // Get customer dashboard data from server.
    case GET_CUSTOMERDASHBOARDDATA:
      return {
        ...state,
        data: state.dashboardData,
        dates: {
          startDate: moment()
            .subtract(action.payload.filter, "days")
            .format("YYYY-MM-DD"),
          endDate: moment().format("YYYY-MM-DD"),
        },
        filterDomains: action.payload.domains ? action.payload.domains : [],
        loading: true,
        noDataStatus: false,
        trendSeries: [],
        trendDays: [],
      };
    // On Success...
    case GET_CUSTOMERDASHBOARDDATA_SUCCESS:
      return {
        ...state,
        loading: false,
        profileData: action.payload.profileData,
        cmpData: action.payload.cmpData,
      };
    // On Failure, show error message.
    case GET_CUSTOMERDASHBOARDDATA_FAILURE:
      return { ...state, loading: false, noDataStatus: true };

    default:
      return { ...state, loading: false };
  }
};
